exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-table-text{color:white}.report-table-date{opacity:80%}.report-table-creator{width:20%}.report-table-resources{width:25%}.report-table-editor{width:20%}.report-table-edit-date{width:20%}.report-table-version{width:10%}.report-table-export{width:5%}.report-table-published{color:#5cb85c !important}\n", ""]);

// exports
